<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="300px">
      <template v-slot:activator="{ on }">
        <v-btn color="secondary" outlined dark v-on="on"
          >Afficher l'experience</v-btn
        >
      </template>
      <v-card>
        <v-card-title
          ><small> L'experience de {{ coachName }}</small></v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <ul class="timeline">
            <li class="event" v-for="(item, i) in experiences" :key="i">
              <h3>{{ item.label }} - {{ item.duration }} ans</h3>
              <span class="font-weight-light">Etablissement: {{ item.host }}</span>
              <p>
                {{ item.expDescription }}
              </p>
            </li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Fermer</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import ExperienceComponent from "@/components/partnerComponents/ExperienceComponent.vue";
export default {
  props: ["experiences", "coachName"],
  components: {
    ExperienceComponent,
  },
  data() {
    return {
      dialogm1: "",
      dialog: false,
    };
  },
};
</script>

<style scoped>
.timeline {
  border-left: 4px solid #e91e24;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  background: rgba(255, 255, 255, 0.03);
  color: #313534;
  letter-spacing: 0.5px;
  position: relative;
  line-height: 1.4em;
  font-size: 1.03em;
  padding: 25px 0px 50px 25px;
  list-style: none;
  text-align: left;
  font-weight: 100;
  max-width: 100%;
}
.timeline h1,
.timeline h2,
.timeline h3 {
  font-family: "Oswald", sans-serif;
  letter-spacing: 1.2px;
  font-weight: 400;
  font-size: 17px;
}
.timeline .event {
  border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
  padding-bottom: 25px;
  margin-bottom: 20px;
  position: relative;
  width: 100%;
}
.timeline .event:last-of-type {
  padding-bottom: 0;
  margin-bottom: 0;
  border: none;
}
.timeline .event:before,
.timeline .event:after {
  position: absolute;
  display: block;
  top: 0;
}
.timeline .event:before {
  left: -217.5px;
  color: rgba(255, 255, 255, 0.4);
  content: attr(data-date);
  text-align: right;
  font-weight: 100;
  font-size: 0.9em;
  min-width: 120px;
}
.timeline .event:after {
  font-size: 30px;
  box-shadow: 0 0 0 4px #e91e24;
  left: -32.85px;
  background: #fff;
  border-radius: 50%;
  height: 11px;
  width: 11px;
  content: "";
  top: 5px;
}
</style>